module.exports = __webpack_public_path__ + "static/media/parawebcv_page-0005.eea5dfc9.jpg";